module.exports = __webpack_public_path__ + "70037c3fd53fbb9d7f6a9f8c955d9df4.jpg";